import { cn } from "@/lib/cn";

export type LogomarkSize = "sm" | "md" | "lg" | "xl";

const SIZE_CLASSES: Record<LogomarkSize, string> = {
  sm: "size-4",
  md: "size-6",
  lg: "size-8",
  xl: "size-12",
};

/**
 * The Studside mark, sourced from the approved raster lockup and optimized
 * into a transparent production asset. Keep the size API stable for callers.
 */
export function Logomark({ size = "md", className }: { size?: LogomarkSize; className?: string }) {
  return (
    <img
      className={cn(SIZE_CLASSES[size], "shrink-0 bg-transparent text-text-primary", className)}
      src="/brand/studside-mark.png"
      alt="Studside"
      width={48}
      height={48}
      draggable={false}
    />
  );
}
